import DetailPayloadDiffField from "./fields/Detail/PayloadDiffField.vue"

const systemModuleSetup = (app) => {

    /**
     * Register Fields
     */
    app.component('detail-payload-diff-field', DetailPayloadDiffField)
}

export { systemModuleSetup }